import { useEffect, useState } from "react";

import { BaseProps } from "../../model/auth";
import { MainContent } from "../../components/mainContent";
import { IUser, getUser, passwordSchema, resetPassword } from "../../model/user";
import { Button, Col, Container, FormGroup, Input, Label, Row } from "reactstrap";
import { ToggleMenu } from "../../components/toggleMenu";
import { faSave } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

interface ChangePasswordProps extends BaseProps {}
export const ChangePasswordPage = (props: ChangePasswordProps) => {
  document.title = "Change password | Acader HR";
  const [user, setUser] = useState<IUser>(null);
  const [passwordErrors, setPasswordErrors] = useState<IUser>({});
  const [saved, setSaved] = useState<boolean>(false);
  const [loading, setLoading] = useState<boolean>(true);
  const [password, setPassword] = useState<string>("");

  useEffect(() => {
    if (props.tokenUser) {
      initialise();
    }
  }, [props.tokenUser]);

  const changePassword = async () => {
    try {
      setPasswordErrors({});
      await passwordSchema.validateSync(user, {
        abortEarly: false,
      });
      setSaved(true);

      let response: any = await resetPassword(user.Email, password);
      if (response && response.status === 200) {
        setSaved(true);
      }
      setPassword("");
    } catch (yupErrors) {
      let errors: IUser = {};
      yupErrors?.inner?.map((x: any) => {
        errors[x.path] = x.message;
      });
      setPasswordErrors(errors);
    } finally {
      setSaved(false);
    }
  };

  const initialise = async () => {
    setLoading(true);
    let response: any = await getUser(props.tokenUser.Id.toString());
    if (response && response.status === 200) {
      let user: IUser = response.data.user;
      setUser(user);
      setLoading(false);
    }
  };

  return (
    <>
      <div className="theme-primary">
        <Container>
          <Row>
            <Col xs={10}>
              <h1>Change password</h1>
              <div className="h1Divider"></div>
            </Col>
            <Col xs={2} className="text-end">
              <ToggleMenu onClick={(toggle) => props.onMenuToggleClick(toggle)} />
            </Col>
          </Row>
        </Container>
      </div>
      <MainContent loading={loading} width={4} saved={saved}>
        <FormGroup>
          <Label>Email</Label>
          <Input type="text" id="txtUserName" disabled value={user?.Email} />
        </FormGroup>

        <FormGroup>
          <Label>Name</Label>
          <Input type="text" id="txtName" disabled value={user?.Firstname + " " + user?.Lastname} />
        </FormGroup>
        <FormGroup>
          <Label className="required">Password</Label>
          <Input
            type="password"
            id="txtPasswordLogin"
            value={password}
            onChange={(e) => {
              e.persist();
              setPassword(e.target.value);
              setUser((x) => ({ ...x, Password: e.target.value }));
            }}
          />
          {passwordErrors.Password && <Label className="text-danger">{passwordErrors.Password}</Label>}
        </FormGroup>

        <div className="d-grid gap-2">
          <Button id="btn-password" data-mdb-button-init data-mdb-ripple-init color="acader" type="button" onClick={async () => await changePassword()}>
            <FontAwesomeIcon icon={faSave} className="me-2" />
            Reset password
          </Button>
        </div>
      </MainContent>
    </>
  );
};
